module.exports = __webpack_public_path__ + "static/media/han-taste-ad7.a53b6563.png";